import $$ from 'cmn-utils'

const baseUrl = "/api/device/alarm/";
export default {
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        Object.keys(params).map(key => {
            if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
        })
        return $$.get(baseUrl + 'list', params)
    },
    total: (params) => {
        return $$.get(baseUrl + 'total', params)

    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    }


}